import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.75 19.108v-7.175L4.5 8.295v7.001q0 .078.038.145a.33.33 0 0 0 .116.116zm1.5 0 6.096-3.551a.33.33 0 0 0 .116-.116.3.3 0 0 0 .038-.145v-7l-6.25 3.637zm-1.654 1.645L3.904 16.88A1.78 1.78 0 0 1 3 15.31V7.689a1.79 1.79 0 0 1 .904-1.569l6.692-3.871a1.77 1.77 0 0 1 1.808 0l6.692 3.871A1.78 1.78 0 0 1 20 7.69v7.623a1.79 1.79 0 0 1-.904 1.569l-6.692 3.872a1.77 1.77 0 0 1-1.808 0m4.76-12.369 2.319-1.337-6.021-3.5a.3.3 0 0 0-.154-.049.3.3 0 0 0-.154.048L9.175 4.803zm-3.856 2.25 2.325-1.353L7.65 5.694 5.325 7.047z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
